import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
}
export function Card({
  children,
  className = ''
}: CardProps) {
  return <div className={`rounded-lg border bg-card text-card-foreground shadow-sm ${className}`} data-id="element-478">
      {children}
    </div>;
}
export function CardHeader({
  children,
  className = ''
}: CardProps) {
  return <div className={`flex flex-col space-y-1.5 p-6 ${className}`} data-id="element-479">
      {children}
    </div>;
}
export function CardTitle({
  children,
  className = ''
}: CardProps) {
  return <h3 className={`text-2xl font-semibold leading-none tracking-tight ${className}`} data-id="element-480">
      {children}
    </h3>;
}
export function CardDescription({
  children,
  className = ''
}: CardProps) {
  return <p className={`text-sm text-muted-foreground ${className}`} data-id="element-481">{children}</p>;
}
export function CardContent({
  children,
  className = ''
}: CardProps) {
  return <div className={`p-6 pt-0 ${className}`} data-id="element-482">{children}</div>;
}
export function CardFooter({
  children,
  className = ''
}: CardProps) {
  return <div className={`flex items-center p-6 pt-0 ${className}`} data-id="element-483">{children}</div>;
}